var UITab = (function ($) {

    UITab = function () {
        var that = this;

        // CONST
        that.class = {
            is_active: 'is-active'
        };

        // INIT
        that.init();
    };

    UITab.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UITab.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.js-tab-heading', function () {
            var $tab = $(this);

            that.switchTabHeader($tab);
            that.switchTabContent($tab);

            return false;
        });

        $(window).on('hashchange load', function (e) {
            var hash = window.location.hash,
                $wrapper = $('.js-tabs-wrapper');

            if (!!hash && $wrapper.length) {
                var $tab_item = $wrapper.find('[data-tab-for=' + hash.substring(1) + ']').first();
                if ($tab_item.length) {
                    that.switchTabHeader($tab_item);
                    that.switchTabContent($tab_item);
                }
            }
        });
    };

    UITab.prototype.switchTabHeader = function ($tab) {
        var that = this,
            $wrapper = $tab.parents('.js-tabs-wrapper').first();

        $wrapper
            .find('.js-tab-heading')
            .removeClass(that.class.is_active);

        $tab.addClass(that.class.is_active);
    };

    UITab.prototype.switchTabContent = function ($tab) {
        var that = this,
            $wrapper = $tab.parents('.js-tabs-wrapper').first(),
            tab_for = $tab.attr('data-tab-for'),
            $tab_item = $wrapper.find('[data-tab-id=' + tab_for + ']');

        $wrapper
            .find('.js-tab-content')
            .removeClass(that.class.is_active);

        if ($tab_item.length) {
            $tab_item.addClass(that.class.is_active);
        } else {
            var error_message = 'UITab ERROR: Can`t find [data-tab-id=' + tab_for + '] selector!';
            error_message += '\n' + 'Check your markup.'
            console.error(error_message);
        }
    };

    return UITab;
})($);